import classNames from 'classnames';
import type { Featherico } from 'featherico';
import type * as React from 'react';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import history from '../../../routing/history';
import { interpolateAppUrl } from '../../services/Url';
import LinkButton from '../LinkButton';
import styles from './styles.m.less';

type SelectButtonProps = {
    route: string; // if it's an in-app route
    title: string;
    description: string;
    icon: React.ComponentType<Featherico>;
    onClose: () => void;
    color: 'SALMON' | 'TURQUOISE';
    dataIntercomTarget?: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export function SelectButton({
    route,
    title,
    description,
    icon: Icon,
    onClose,
    color,
    ...passedProps
}: SelectButtonProps): ReactElement {
    useEffect(() => {
        if (history) {
            return history.listen(() => onClose());
        }
    }, [onClose]);

    return (
        <LinkButton href={interpolateAppUrl(route, {})} kind="PLAIN" className={styles.selectButton} {...passedProps}>
            <Icon className={classNames(styles.icon, [color === 'TURQUOISE' ? styles.turquoise : styles.salmon])} />
            <div className={styles.title}>{title}</div>
            <div className={styles.description}>{description}</div>
        </LinkButton>
    );
}
